import { render, staticRenderFns } from "./TotalBannerInteractions.vue?vue&type=template&id=47b9c33e&"
import script from "./TotalBannerInteractions.vue?vue&type=script&lang=js&"
export * from "./TotalBannerInteractions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports